import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=3ff2d902&scoped=true"
import script from "./ImageInfo.vue?vue&type=script&lang=js"
export * from "./ImageInfo.vue?vue&type=script&lang=js"
import style0 from "./ImageInfo.vue?vue&type=style&index=0&id=3ff2d902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2d902",
  null
  
)

export default component.exports